/**
 * One-call factory for the main thread: spins up the sim worker and returns
 * the ready-to-use client. This is the drop-in for src/ui/bridge.ts - UI
 * lanes import createSimClient, never construct workers themselves.
 * Vite bundles the worker entry via the URL constructor form.
 */
import { SimWorkerClient } from './bridge';
import type { StorageAdapter } from '../save/save-manager';

export interface SimClientHandle {
  client: SimWorkerClient;
  worker: Worker;
}

export async function createSimClient(seed: number, storage?: StorageAdapter): Promise<SimClientHandle> {
  const worker = new Worker(new URL('./sim-worker.ts', import.meta.url), { type: 'module' });
  const client = new SimWorkerClient(worker, storage);
  await client.init(seed);
  return { client, worker };
}
